import { useGetRole } from "../../lib/hooks/getRole";
import { AdminHeader } from "./components/Admin";
import { UserHeader } from "./components/User";

export const Header = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, isAdmin] = useGetRole();

  return isAdmin ? <AdminHeader /> : <UserHeader />;
};
